<template>
  <div>
    <v-navigation-drawer v-model="drawer" app class="sns-drawer">
      <v-list-item
        v-if="roleName != 'CANDIDATE' && roleName != 'COMPANY'"
        class="my-4 mx-2 px-16"
      >
        <router-link to="/">
          <v-img
            alt="SNS"
            contain
            :src="require('../../assets/sns.jpeg')"
            width="100"
          />
        </router-link>
      </v-list-item>
      <v-list-item v-else class="my-4 mx-2 px-16">
        <router-link to="/profile">
          <v-img
            alt="SNS"
            contain
            :src="require('../../assets/sns.jpeg')"
            width="100"
          />
        </router-link>
      </v-list-item>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item
          v-ripple="{ class: 'primary--text' }"
          :to="`/profile`"
          class="v-list-item"
        >
          <v-list-item-icon>
            <v-icon size="25"> mdi-account </v-icon>
          </v-list-item-icon>

          <v-list-item-title class="text-subtitle-1"
            >My Profile</v-list-item-title
          >
        </v-list-item>
        <!-- Companies -->
        <!-- <v-list-item v-ripple="{ class: 'primary--text' }" v-if="roleName == 'ADMIN' || roleName == 'SUPER ADMIN'"
          :to="`/companies`" class="v-list-item">
          <v-list-item-icon>
            <v-icon size="25"> mdi-factory </v-icon>
          </v-list-item-icon>

          <v-list-item-title class="text-subtitle-1">Companies</v-list-item-title>
        </v-list-item> -->

        <!-- Users -->
        <v-list-group
          no-action
          :value="false"
          v-if="
            roleName == 'ADMIN' ||
            roleName == 'SUPER ADMIN' ||
            roleName == 'MANAGER' ||
            roleName == 'TEACHER' ||
            user.rank == 'VESSEL ADMIN'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25"> mdi-calendar-account </v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">Data</v-list-item-title>
          </template>

          <v-list-item :to="`/users`" class="v-list-item" v-if="canViewCandidates">
            <v-list-item-icon>
              <v-icon size="25"> mdi-account-group </v-icon>
            </v-list-item-icon>

            <v-list-item-title class="text-subtitle-1"
              >Candidates</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            :to="`/teacher`"
            class="v-list-item"
            v-if="roleName == 'ADMIN' || roleName == 'SUPER ADMIN' || roleName == 'MANAGER'"
          >
            <v-list-item-icon>
              <v-icon size="25"> mdi-account</v-icon>
            </v-list-item-icon>

            <v-list-item-title class="text-subtitle-1"
              >Teachers</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            :to="`/admin`"
            class="v-list-item"
            v-if="roleName == 'SUPER ADMIN'"
          >
            <v-list-item-icon>
              <v-icon size="25"> mdi-account-badge </v-icon>
            </v-list-item-icon>

            <v-list-item-title class="text-subtitle-1">Admin</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="`/company`"
            class="v-list-item"
            v-if="roleName == 'ADMIN' || roleName == 'SUPER ADMIN' || roleName == 'MANAGER'"
          >
            <v-list-item-icon>
              <v-icon size="25"> mdi-domain </v-icon>
            </v-list-item-icon>

            <v-list-item-title class="text-subtitle-1"
              >Company</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            :to="`/certificates`"
            class="v-list-item"
            v-if="
              roleName == 'ADMIN' ||
              roleName == 'SUPER ADMIN' ||
              roleName == 'MANAGER' ||
              roleName == 'TEACHER'
            "
          >
            <v-list-item-icon>
              <v-icon size="25"> mdi-certificate </v-icon>
            </v-list-item-icon>

            <v-list-item-title class="text-subtitle-1"
              >Certificate</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            :to="`/deleted-candidates`"
            class="v-list-item"
            v-if="roleName == 'MANAGER'"
          >
            <v-list-item-icon>
              <v-icon size="25"> mdi-account-off </v-icon>
            </v-list-item-icon>

            <v-list-item-title class="text-subtitle-1"
              >Deleted Candidates</v-list-item-title
            >
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-ripple="{ class: 'primary--text' }"
          :to="`/course`"
          class="v-list-item"
        >
          <v-list-item-icon>
            <v-icon size="25"> mdi-book </v-icon>
          </v-list-item-icon>

          <v-list-item-title class="text-subtitle-1">Courses</v-list-item-title>
        </v-list-item>
        <!-- Users -->
        <!-- <v-list-item :to="`/geofence/create`">
            <v-list-item-icon>
              <v-icon size="25"> mdi-shape </v-icon>
            </v-list-item-icon>
            <v-list-item-title>GeoFence</v-list-item-title>
          </v-list-item> -->
        <!-- Reports -->
        <!-- Settings -->
        <v-list-group
          no-action
          :value="false"
          v-if="
            roleName == 'SUPER ADMIN' ||
            roleName == 'ADMIN' ||
            roleName == 'MANAGER' ||
            roleName == 'TEACHER' ||
            user.rank == 'VESSEL ADMIN'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size=" 25">mdi-cogs</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Settings</v-list-item-title
            >
          </template>

          <v-list-item :to="`/values`"  v-if="roleName == 'ADMIN' || roleName == 'SUPER ADMIN' || roleName == 'MANAGER'">
            <v-list-item-icon>
              <v-icon size="25"> mdi-shape </v-icon>
            </v-list-item-icon>
            <v-list-item-title>Values</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/value-lists`"  v-if="roleName == 'ADMIN' || roleName == 'SUPER ADMIN' || roleName == 'MANAGER'">
            <v-list-item-icon>
              <v-icon size="25">mdi-arrow-expand-all</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Value Lists</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="`/orgs`"
            class="v-list-item"
            v-if="roleName == 'ADMIN' || roleName == 'SUPER ADMIN' || roleName == 'MANAGER'"
          >
            <v-list-item-icon>
              <v-icon size="25"> mdi-account-file </v-icon>
            </v-list-item-icon>

            <v-list-item-title class="text-subtitle-1">Org</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="`/network-settings`"
            class="v-list-item"
            v-if="isElectron &&   user.rank == 'MASTER' ||
            user.rank == 'VESSEL ADMIN'"
          >
            <v-list-item-icon>
              <v-icon size="25"> mdi-lan </v-icon>
            </v-list-item-icon>

            <v-list-item-title class="text-subtitle-1">Network Settings</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <div class="text-center mb-2">
            <a href="mailto:support@aaibuzz.com" class="support-link"> contact us: <v-icon small color="grey">mdi-email</v-icon> support@aaibuzz.com</a>
          </div>
          <v-btn class="primary" block color="white" text @click="logout">
            Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app class="sns-appbar">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn color="black" small text>
        {{ user.name != null ? user.name : user.email }}
        [ {{ roleName }}]
      </v-btn>
    </v-app-bar>

    <transition name="page" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script type="text/javascript">
import { mapActions } from "vuex";

export default {
  data() {
    return {
      drawer: true,
      companyName: "",
      companyId: "",
    };
  },
  mounted() {},
  components: {},
  computed: {
    isElectron() {
      return window && window.electron;
    },
    // Who may see the Candidates list: Super Admin / Admin (role) or Vessel Admin
    // (rank). MASTER is a real job rank, not a permission, so it does NOT qualify.
    canViewCandidates() {
      return (
        this.roleName == "SUPER ADMIN" ||
        this.roleName == "ADMIN" ||
        this.roleName == "MANAGER" ||
        (this.user && this.user.rank == "VESSEL ADMIN")
      );
    },
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    async logout() {
      await this.logOut();
      // Clear any cached data
      localStorage.removeItem('token');
      // Force full page reload to clear any in-memory state
      window.location.href = '/';
    },
  },
};
</script>
<style scoped>
.nav-text {
  text-decoration: none;
  color: black;
  font-weight: bold;
  font-size: 20px;
}

.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding: 0 8px 0 20px;
}

.support-link {
  color: #666;
  text-decoration: none;
  font-size: 12px;
  margin-left: 4px;
}

.support-link:hover {
  color: #1976d2;
  text-decoration: underline;
}
</style>
